/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";

//componenets
import Button from "../../../component/button";
import Input from "../../../component/inputpm";

//select comp
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

import TextField from "@mui/material/TextField";

//add table
import ProviderTable from "./providerTable";

//dialogs
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import Icon from "@mui/material/Icon";

import PdfViewer from "./pdfViewer";

// API helper and constant
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import actionTypes from "../../../store/actions";

// Loader
import Loader from "../../../component/loader";

// Upload document dialog
import UploadDocumentsDialog from "./uploadDocumentsDialog";
import EditContract from "./editContract";

import ViewRequestorsDialog from "./viewRequestorDialog";
import { withTranslation } from "react-i18next";
import { Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Draggable from "react-draggable";
import { Paper, Tooltip, DialogContentText } from "@mui/material";
// import { withStyles } from '@mui/styles';
import dateFormat from "dateformat";
import {formatDate} from "../../../helper/dateFormatter";

class ContractManagement extends Component {
  state = {
    title: "",
    description: "",
    parties: {},
    effectiveDate: "",
    expiryDate: "",
    providerList: [],
    loading: false,
    myAllContracts: [],
    inboundContracts: [],
    outboundContracts: [],
    today: "",
    selectedContractId: "",
    selectedContractReceiver: {},
    documentDescription: "",
    documentName: "",
    docEffectiveDate: "",
    docExpiryDate: "",
    openAddContract: false,

    //used to add table data
    tableCell: [],

    //prepare contracts
    contracts: [],

    //to get party to ids
    contractForPartyList: [],

    //dialog box
    open: false,
    //pdf dialog
    pdfView: false,

    //pdf doc base64
    base64PdfDocument: "",

    salesChannelProvidersList: [],
    solutionProvidersList: [],
    serviceProvidersList: [],
    searching: true,
    openEditContract: false,
    selectedContractToEdit: {},
    outboundSortBy: "title",
    outboundSortOrder: "ASC",
    inboundSortBy: "title",
    inboundSortOrder: "ASC",
    requestorsListContractId: "",
    showRequestorsDialog: false,
    openDeleteDialog: false,
    selectedContractToDelete: {},
    requestedContractId: "",
    copyContract: false,
    documentFile: "",
    selectedContractTitle: "",
    selectedEffectiveDate: "",
    selectedExpiryDate: "",
    typeId: "all",
    error: {},
  };

  //TODO: Call fromm provider.js
  onChange = (e) => {
    this.props.setErrorMessage("");
    if (e.target.name === "type") {
      if (e.target.value === "SALES_CHNL_PROVIDER") {
        this.setState({
          providerList: this.state.salesChannelProvidersList,
        });
      } else if (e.target.value === "SOLUTION_PROVIDER") {
        this.setState({
          providerList: this.state.solutionProvidersList,
        });
      } else if (e.target.value === "SERVICE_PROVIDER") {
        this.setState({
          providerList: this.state.serviceProvidersList,
        });
      }
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  // Validate contract form
  validateContract = () => {
    const error = {};
    const { t } = this.props;
    if (!this.state.title) {
      error.title = t("CONTRACT_TITLE_IS_REQUIRED");
      // this.props.setErrorMessage(this.props.t('CONTRACT_TITLE_IS_REQUIRED'));
    }
    if (!this.state.type) {
      error.type = t("RECEPIENT_PROVIDER_TYPE_IS_REQUIRED");
      // this.props.setErrorMessage(this.props.t('RECEPIENT_PROVIDER_TYPE_IS_REQUIRED'));
    }
    if (!this.state.effectiveDate) {
      error.effectiveDate = t("EFFECTIVE_DATE_IS_REQUIRED");
      // this.props.setErrorMessage(this.props.t('EFFECTIVE_DATE_IS_REQUIRED'));
    }
    if (!this.state.base64PdfDocument) {
      error.base64PdfDocument = t("DOCUMENT_IS_REQUIRED");
      // this.props.setErrorMessage(this.props.t('DOCUMENT_IS_REQUIRED'));
    }
    // else {
    //     return true
    // }
    this.setState({ error });
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  //function to add the contract details
  addContractDetails = () => {
    // this.setState({
    //     loading: true,
    // })
    if (this.validateContract()) {
      this.setState({
        loading: true,
      });
      let data = {
        title: this.state.title,
        description: this.state.description,
        parties: {
          from: {
            id: this.props.tenantId,
            type: this.props.providerType,
          },
          to: {
            id:
              !this.state.typeId || this.state.typeId === "all"
                ? ""
                : this.state.typeId,
            type: this.state.type,
          },
        },
        effectiveDate: this.state.effectiveDate + " 00:00:00",
        expiryDate: this.state.expiryDate
          ? this.state.expiryDate + " 00:00:00"
          : "",
        status: "Draft",
      };

      let docData = {
        type: "SERVICE_AGREEMENT",
        signing: {
          sender: {
            id: this.props.tenantId,
            type: this.props.providerType,
            locations: [
              {
                pageNumber: 3,
                x: 155,
                y: 233,
                type: "FULL_SIGNATURE",
              },
              {
                pageNumber: 4,
                x: 234,
                y: 432,
                type: "INITIAL",
              },
            ],
          },
          receiver: {
            id:
              !this.state.typeId || this.state.typeId === "all"
                ? ""
                : this.state.typeId,
            type: this.state.type,
            locations: [
              {
                pageNumber: 1,
                x: 201,
                y: 102,
                type: "INITIAL",
              },
              {
                pageNumber: 10,
                x: 452,
                y: 276,
                type: "FULL_SIGNATURE",
              },
            ],
          },
        },
        document: {
          name: this.state.documentFile,
          format: "PDF",
          status: "AVAILABLE",
          effectiveDate: this.state.effectiveDate + " 00:00:00",
          expiryDate: this.state.expiryDate
            ? this.state.expiryDate + " 00:00:00"
            : "",
          description: this.state.documentDescription,
          data: this.state.base64PdfDocument,
        },
      };

      BusApiCall(
        "POST",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts`,
        data,
      )
        .then((res) => {
          BusApiCall(
            "POST",
            `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${res.data.id}/items`,
            docData,
          )
            .then((res) => {
              this.setState({
                documentDescription: "",
                base64PdfDocument: "",
                documentFile: "",
                openAddContract: false,
                title: "",
                description: "",
                type: "",
                typeId: "all",
                effectiveDate: "",
                expiryDate: "",
                providerList: [],
              });
              this.props.setErrorMessage(
                this.props.t("CONTRACT_ADDED_SUCCESSFULLY"),
                true,
              );
              this.getAllContrats();
            })
            .catch((error) => {
              this.props.setErrorMessage(
                this.props.t("UNABLE_TO_UPLOAD_DOCUMENT_PLEASE_TRY_AGAIN"),
                false,
              );
              this.setState({
                loading: false,
                openAddContract: false,
              });
            });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            openAddContract: false,
          });
        });
    }
  };

  addDocuments = (id, receiver, title, effectiveDate, expiryDate) => {
    this.setState({
      selectedContractId: id,
      selectedContractReceiver: receiver,
      selectedContractTitle: title,
      selectedEffectiveDate: effectiveDate,
      selectedExpiryDate: expiryDate,
      open: true,
    });
  };

  closeDocumentDialog = (message, type) => {
    if (message) {
      this.props.setErrorMessage(message, type);
      if (type) {
        this.getAllContrats();
      }
      this.setState({
        open: false,
      });
    } else {
      this.setState({
        open: false,
        selectedContractId: "",
        selectedContractReceiver: "",
        selectedContractTitle: "",
      });
    }
  };

  closePdfView = () => {
    this.setState({
      pdfView: false,
    });
  };

  markDocument = () => {
    this.setState(
      {
        pdfView: true,
      },
      () => {},
    );
  };

  componentDidMount() {
    this.props.onRef(this);
    let date = new Date();
    let today = `${date.getFullYear()}-${date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
    this.setState({
      today: today,
    });
    this.getIntialData();
  }

  // Get all contracts data
  getAllContrats = () => {
    this.setState({
      loading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.tenantId}/contracts`,
    )
      .then((res) => {
        let inbound = [];
        let outbound = [];
        let tempOutbound = res.data.contracts.outboundContracts;
        let tempInbound = res.data.contracts.inboundContracts;
        for (let i = 0; i < tempOutbound.length; i++) {
          if (tempOutbound[i].status !== "Deleted") {
            if (tempOutbound[i].parties.to.id) {
              if (tempOutbound[i].parties.to.type === "SALES_CHNL_PROVIDER") {
                let obj = this.state.salesChannelProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              } else if (
                tempOutbound[i].parties.to.type === "SOLUTION_PROVIDER"
              ) {
                let obj = this.state.solutionProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              } else if (
                tempOutbound[i].parties.to.type === "SERVICE_PROVIDER"
              ) {
                let obj = this.state.serviceProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              }
            } else {
              tempOutbound[i].parties.to.name = "All";
            }
            if (tempOutbound[i].expiryDate) {
              if (
                tempOutbound[i].expiryDate.split(" ")[0] < this.formatDate()
              ) {
                tempOutbound[i].status = "Expired";
              }
            }
            outbound.push(tempOutbound[i]);
          }
        }
        for (let i = 0; i < tempInbound.length; i++) {
          if (tempInbound[i].status !== "Deleted") {
            if (tempInbound[i].parties.from.type === "SALES_CHNL_PROVIDER") {
              let obj = this.state.salesChannelProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            } else if (
              tempInbound[i].parties.from.type === "SOLUTION_PROVIDER"
            ) {
              let obj = this.state.solutionProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            } else if (
              tempInbound[i].parties.from.type === "SERVICE_PROVIDER"
            ) {
              let obj = this.state.serviceProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            }
            inbound.push(tempInbound[i]);
          }
        }
        outbound.sort((a, b) => {
          if (this.state.outboundSortOrder === "ASC") {
            if (
              this.state.outboundSortBy === "providerType" ||
              this.state.outboundSortBy === "providerName"
            ) {
              let type =
                this.state.outboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.to[type] < b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] > b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
                return -1;
              }
              if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
                return 1;
              }
              return 0;
            }
          } else {
            if (
              this.state.outboundSortBy === "providerType" ||
              this.state.outboundSortBy === "providerName"
            ) {
              let type =
                this.state.outboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.to[type] > b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] < b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
                return -1;
              }
              if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
                return 1;
              }
              return 0;
            }
          }
        });
        inbound.sort((a, b) => {
          if (this.state.inboundSortOrder === "ASC") {
            if (
              this.state.inboundSortBy === "providerType" ||
              this.state.inboundSortBy === "providerName"
            ) {
              let type =
                this.state.inboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.from[type] < b.parties.from[type]) {
                return -1;
              }
              if (a.parties.from[type] > b.parties.from[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
                return -1;
              }
              if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
                return 1;
              }
              return 0;
            }
          } else {
            if (
              this.state.inboundSortBy === "providerType" ||
              this.state.inboundSortBy === "providerName"
            ) {
              let type =
                this.state.inboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.from[type] > b.parties.from[type]) {
                return -1;
              }
              if (a.parties.from[type] < b.parties.from[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
                return -1;
              }
              if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
                return 1;
              }
              return 0;
            }
          }
        });
        this.setState({
          myAllContracts: res.data,
          inboundContracts: inbound,
          outboundContracts: outbound,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  formatDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  getIntialData = () => {
    this.setState({
      loading: true,
    });
    Promise.all([
      BusApiCall("GET", `${constants.busV4Url}/sales-channel-providers`),
      BusApiCall("GET", `${constants.busV4Url}/solution-providers`),
      BusApiCall("GET", `${constants.busV4Url}/service-providers`),
      BusApiCall(
        "GET",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts`,
      ),
    ])
      .then((res) => {
        let salesChannelProvidersList = res[0].data;
        let solutionProvidersList = res[1].data;
        let serviceProvidersList = res[2].data;

        let myAllContracts = res[3].data;
        let inbound = [];
        let outbound = [];
        let tempOutbound = myAllContracts.contracts.outboundContracts;
        let tempInbound = myAllContracts.contracts.inboundContracts;
        for (let i = 0; i < tempOutbound.length; i++) {
          if (tempOutbound[i].status !== "Deleted") {
            if (tempOutbound[i].parties.to.id) {
              if (tempOutbound[i].parties.to.type === "SALES_CHNL_PROVIDER") {
                let obj = salesChannelProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              } else if (
                tempOutbound[i].parties.to.type === "SOLUTION_PROVIDER"
              ) {
                let obj = solutionProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              } else if (
                tempOutbound[i].parties.to.type === "SERVICE_PROVIDER"
              ) {
                let obj = serviceProvidersList.find(
                  (x) => x.id === tempOutbound[i].parties.to.id,
                );
                tempOutbound[i].parties.to.name = obj.name;
              }
            } else {
              tempOutbound[i].parties.to.name = "All";
            }
            if (tempOutbound[i].expiryDate) {
              if (
                tempOutbound[i].expiryDate.split(" ")[0] < this.formatDate()
              ) {
                tempOutbound[i].status = "Expired";
              }
            }
            outbound.push(tempOutbound[i]);
          }
        }
        for (let i = 0; i < tempInbound.length; i++) {
          if (tempInbound[i].status !== "Deleted") {
            if (tempInbound[i].parties.from.type === "SALES_CHNL_PROVIDER") {
              let obj = salesChannelProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            } else if (
              tempInbound[i].parties.from.type === "SOLUTION_PROVIDER"
            ) {
              let obj = solutionProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            } else if (
              tempInbound[i].parties.from.type === "SERVICE_PROVIDER"
            ) {
              let obj = serviceProvidersList.find(
                (x) => x.id === tempInbound[i].parties.from.id,
              );
              tempInbound[i].parties.from.name = obj.name;
            }
            inbound.push(tempInbound[i]);
          }
        }
        outbound.sort((a, b) => {
          if (this.state.outboundSortOrder === "ASC") {
            if (
              this.state.outboundSortBy === "providerType" ||
              this.state.outboundSortBy === "providerName"
            ) {
              let type =
                this.state.outboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.to[type] < b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] > b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
                return -1;
              }
              if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
                return 1;
              }
              return 0;
            }
          } else {
            if (
              this.state.outboundSortBy === "providerType" ||
              this.state.outboundSortBy === "providerName"
            ) {
              let type =
                this.state.outboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.to[type] > b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] < b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
                return -1;
              }
              if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
                return 1;
              }
              return 0;
            }
          }
        });
        inbound.sort((a, b) => {
          if (this.state.inboundSortOrder === "ASC") {
            if (
              this.state.inboundSortBy === "providerType" ||
              this.state.inboundSortBy === "providerName"
            ) {
              let type =
                this.state.inboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.from[type] < b.parties.from[type]) {
                return -1;
              }
              if (a.parties.from[type] > b.parties.from[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
                return -1;
              }
              if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
                return 1;
              }
              return 0;
            }
          } else {
            if (
              this.state.inboundSortBy === "providerType" ||
              this.state.inboundSortBy === "providerName"
            ) {
              let type =
                this.state.inboundSortBy === "providerName" ? "name" : "type";
              if (a.parties.from[type] > b.parties.from[type]) {
                return -1;
              }
              if (a.parties.from[type] < b.parties.from[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
                return -1;
              }
              if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
                return 1;
              }
              return 0;
            }
          }
        });
        this.setState({
          salesChannelProvidersList: salesChannelProvidersList,
          solutionProvidersList: solutionProvidersList,
          serviceProvidersList: serviceProvidersList,
          myAllContracts: myAllContracts,
          inboundContracts: inbound,
          outboundContracts: outbound,
          loading: false,
          searching: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  openContractModal = () => {
    this.props.setErrorMessage("");
    this.setState({
      openAddContract: true,
    });
  };

  closeContractModal = (val) => {
    if (val) {
      this.addContractDetails();
    } else {
      this.setState({
        openAddContract: false,
        title: "",
        description: "",
        type: "",
        typeId: "all",
        effectiveDate: "",
        expiryDate: "",
        error: {},
      });
    }
  };

  acceptContract = (item, id) => {
    let data = { ...item };
    data.status = "In Progress";
    if (!data.description) {
      data.description = "";
    }
    if (!data.expiryDate) {
      data.expiryDate = "";
    }
    delete data.id;
    delete data.items;
    delete data.parties.from.name;
    this.setState({ loading: true });
    BusApiCall(
      "PATCH",
      `${constants.busV4Url}/providers/${item.parties.from.id}/contracts/${id}`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t(
            "CONTRACT_ACCEPTED_YOU_SHOULD_EXPECT_AN_E-MAIL_FOR_ELECTRONIC_SIGNATURE",
          ),
          true,
        );
        this.getAllContrats();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  publishContract = (item, id) => {
    let data = { ...item };
    data.status = "Published";
    if (!data.description) {
      data.description = "";
    }
    if (!data.expiryDate) {
      data.expiryDate = "";
    }
    data.parties.to.id = data.parties.to.id ? data.parties.to.id : "";
    delete data.id;
    delete data.items;
    delete data.parties.from.name;
    delete data.parties.to.name;
    this.setState({ loading: true });
    BusApiCall(
      "PATCH",
      `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${id}`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage("Contract Published Successfully.", true);
        this.getAllContrats();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  editContract = (data) => {
    let selectedData = {};
    selectedData.title = data.title;
    selectedData.effectiveDate = data.effectiveDate.split(" ")[0];
    selectedData.expiryDate = data.expiryDate
      ? data.expiryDate.split(" ")[0]
      : "";
    selectedData.description = data.description ? data.description : "";
    selectedData.status = data.status;
    selectedData.partyFromId = data.parties.from.id;
    selectedData.partyFromType = data.parties.from.type;
    selectedData.partyToId = data.parties.to.id ? data.parties.to.id : "";
    selectedData.partyToType = data.parties.to.type;
    selectedData.id = data.id;
    this.setState({
      selectedContractToEdit: selectedData,
      openEditContract: true,
    });
  };

  closeUpdateContract = (obj) => {
    if (obj) {
      let data = {};
      data.title = obj.title;
      data.effectiveDate = obj.effectiveDate + " 00:00:00";
      data.expiryDate = obj.expiryDate ? obj.expiryDate + " 00:00:00" : "";
      data.description = obj.description;
      data.status = obj.status;
      data.parties = {
        from: {
          id: obj.partyFromId,
          type: obj.partyFromType,
        },
        to: {
          type: obj.partyToType,
          id: obj.partyToId,
        },
      };

      this.setState({ loading: true });
      BusApiCall(
        "PATCH",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${obj.id}`,
        data,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("Contract Updated Successfully"),
            true,
          );
          this.setState({
            selectedContractToEdit: {},
            openEditContract: false,
          });
          this.getAllContrats();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            selectedContractToEdit: {},
            openEditContract: false,
          });
        });
    } else {
      this.setState({
        selectedContractToEdit: {},
        openEditContract: false,
      });
    }
  };

  deleteContract = (obj) => {
    this.setState({
      selectedContractToDelete: obj,
      openDeleteDialog: true,
    });
  };

  updateOutboundSorting = (sortBy) => {
    if (sortBy === this.state.outboundSortBy) {
      let outboundSortOrder =
        this.state.outboundSortOrder === "ASC" ? "DESC" : "ASC";
      this.setState({
        outboundSortOrder:
          this.state.outboundSortOrder === "ASC" ? "DESC" : "ASC",
      });
      let data = this.state.outboundContracts;
      data.sort((a, b) => {
        if (outboundSortOrder === "ASC") {
          if (
            this.state.outboundSortBy === "providerType" ||
            this.state.outboundSortBy === "providerName"
          ) {
            let type =
              this.state.outboundSortBy === "providerName" ? "name" : "type";
            if (a.parties.to[type] < b.parties.to[type]) {
              return -1;
            }
            if (a.parties.to[type] > b.parties.to[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
              return -1;
            }
            if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
              return 1;
            }
            return 0;
          }
        } else {
          if (
            this.state.outboundSortBy === "providerType" ||
            this.state.outboundSortBy === "providerName"
          ) {
            let type =
              this.state.outboundSortBy === "providerName" ? "name" : "type";
            if (a.parties.to[type] > b.parties.to[type]) {
              return -1;
            }
            if (a.parties.to[type] < b.parties.to[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.outboundSortBy] > b[this.state.outboundSortBy]) {
              return -1;
            }
            if (a[this.state.outboundSortBy] < b[this.state.outboundSortBy]) {
              return 1;
            }
            return 0;
          }
        }
      });
      this.setState({ outboundContracts: data });
    } else {
      this.setState({
        outboundSortOrder: "ASC",
        outboundSortBy: sortBy,
      });
      let data = this.state.outboundContracts;
      data.sort((a, b) => {
        if (sortBy === "providerType" || sortBy === "providerName") {
          let type = sortBy === "providerName" ? "name" : "type";
          if (a.parties.to[type] < b.parties.to[type]) {
            return -1;
          }
          if (a.parties.to[type] > b.parties.to[type]) {
            return 1;
          }
          return 0;
        } else {
          if (a[sortBy] < b[sortBy]) {
            return -1;
          }
          if (a[sortBy] > b[sortBy]) {
            return 1;
          }
          return 0;
        }
      });
      this.setState({ outboundContracts: data });
    }
  };

  updateInboundSorting = (sortBy) => {
    if (sortBy === this.state.inboundSortBy) {
      let inboundSortOrder =
        this.state.inboundSortOrder === "ASC" ? "DESC" : "ASC";
      this.setState({
        inboundSortOrder:
          this.state.inboundSortOrder === "ASC" ? "DESC" : "ASC",
      });
      let data = this.state.inboundContracts;
      data.sort((a, b) => {
        if (inboundSortOrder === "ASC") {
          if (
            this.state.inboundSortBy === "providerType" ||
            this.state.inboundSortBy === "providerName"
          ) {
            let type =
              this.state.inboundSortBy === "providerName" ? "name" : "type";
            if (a.parties.from[type] < b.parties.from[type]) {
              return -1;
            }
            if (a.parties.from[type] > b.parties.from[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
              return -1;
            }
            if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
              return 1;
            }
            return 0;
          }
        } else {
          if (
            this.state.inboundSortBy === "providerType" ||
            this.state.inboundSortBy === "providerName"
          ) {
            let type =
              this.state.inboundSortBy === "providerName" ? "name" : "type";
            if (a.parties.from[type] > b.parties.from[type]) {
              return -1;
            }
            if (a.parties.from[type] < b.parties.from[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.inboundSortBy] > b[this.state.inboundSortBy]) {
              return -1;
            }
            if (a[this.state.inboundSortBy] < b[this.state.inboundSortBy]) {
              return 1;
            }
            return 0;
          }
        }
      });
      this.setState({ inboundContracts: data });
    } else {
      this.setState({
        inboundSortOrder: "ASC",
        inboundSortBy: sortBy,
      });
      let data = this.state.inboundContracts;
      data.sort((a, b) => {
        if (sortBy === "providerType" || sortBy === "providerName") {
          let type = sortBy === "providerName" ? "name" : "type";
          if (a.parties.from[type] < b.parties.from[type]) {
            return -1;
          }
          if (a.parties.from[type] > b.parties.from[type]) {
            return 1;
          }
          return 0;
        } else {
          if (a[sortBy] < b[sortBy]) {
            return -1;
          }
          if (a[sortBy] > b[sortBy]) {
            return 1;
          }
          return 0;
        }
      });
      this.setState({ inboundContracts: data });
    }
  };

  viewRequestors = (id, title, copyContract) => {
    this.setState({
      requestorsListContractId: id,
      requestedContractId: title,
      showRequestorsDialog: true,
      copyContract: copyContract,
    });
  };

  closeRequestorDialog = (id) => {
    this.setState({
      requestorsListContractId: "",
      requestedContractId: "",
      showRequestorsDialog: false,
      copyContract: false,
    });
    if (id) {
      this.props.changeRoute(id);
    }
  };

  closeDeleteConfirmation = (val) => {
    this.setState({
      openDeleteDialog: false,
    });
    if (val) {
      let obj = this.state.selectedContractToDelete;
      let data = {};
      data.title = obj.title;
      data.effectiveDate = obj.effectiveDate;
      data.expiryDate = obj.expiryDate ? obj.expiryDate : "";
      data.description = obj.description ? obj.description : "";
      data.status = "Deleted";
      data.parties = {
        from: {
          id: obj.parties.from.id,
          type: obj.parties.from.type,
        },
        to: {
          type: obj.parties.to.type,
          id: obj.parties.to.id ? obj.parties.to.id : "",
        },
      };

      this.setState({ loading: true });
      BusApiCall(
        "PATCH",
        `${constants.busV4Url}/providers/${this.props.tenantId}/contracts/${obj.id}`,
        data,
      )
        .then((res) => {
          this.props.setErrorMessage(
            this.props.t("CONTRACT_DELETED_SUCCESSFULLY"),
            true,
          );
          this.getAllContrats();
          this.setState({ selectedContractToDelete: "" });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, selectedContractToDelete: "" });
        });
    }
  };

  onDocumentUpload = (event) => {
    let format = event.target.files[0].name
      .substring(event.target.files[0].name.lastIndexOf(".") + 1)
      .toLowerCase();
    if (format === "pdf") {
      this.setState({ loading: true });
      let selectedFile = event.target.files;
      let file = null;
      let fileName = "";
      //Check File is not Empty
      if (selectedFile.length > 0) {
        // Select the very first file from list
        let fileToLoad = selectedFile[0];
        fileName = fileToLoad.name;
        // FileReader function for read the file.
        let fileReader = new FileReader();
        // Onload of file read the file content
        fileReader.onload = function (fileLoadedEvent) {
          file = fileLoadedEvent.target.result;
        };
        // Convert data to base64
        fileReader.readAsDataURL(fileToLoad);
      }
      setTimeout(
        function () {
          this.setState({
            base64PdfDocument: file,
            documentFile: fileName,
            loading: false,
          });
        }.bind(this),
        2000,
      );
    } else {
      this.props.setErrorMessage(this.props.t("INVALID_FILE_FORMAT"));
    }
  };

  render() {
    const providerTypeList = [
      {
        title: this.props.t("SALES_CHANNEL_PROVIDER"),
        id: "SALES_CHNL_PROVIDER",
      },
      { title: this.props.t("SOLUTION_PROVIDER"), id: "SOLUTION_PROVIDER" },
      { title: this.props.t("SERVICE_PROVIDER"), id: "SERVICE_PROVIDER" },
    ];
    const { t } = this.props;
    const { error } = this.state;
    const { classes: jssClasses } = this.props;
    return (
      <div>
        <Grid container spacing={3}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            {/* Dynamic Table */}
            <ProviderTable
              formatDate={formatDate}
              addDocuments={this.addDocuments}
              myAllContracts={this.state.myAllContracts}
              inboundContracts={this.state.inboundContracts}
              outboundContracts={this.state.outboundContracts}
              acceptContract={this.acceptContract}
              publishContract={this.publishContract}
              searching={this.state.searching}
              editContract={this.editContract}
              deleteContract={this.deleteContract}
              outboundSortBy={this.state.outboundSortBy}
              updateOutboundSorting={this.updateOutboundSorting}
              outboundSortOrder={this.state.outboundSortOrder}
              updateInboundSorting={this.updateInboundSorting}
              inboundSortBy={this.state.inboundSortBy}
              inboundSortOrder={this.state.inboundSortOrder}
              viewRequestors={this.viewRequestors}
              userPerms={this.props.userPerms}
            />
          </Grid>
        </Grid>
        {/* Add contract modal */}
        <Dialog
          disableScrollLock={true}
          open={this.state.openAddContract}
          maxWidth="lg"
          fullWidth={true}
          PaperComponent={this.draggableDialogPaper}
          PaperProps={
            {
              // className: jssClasses.resizablePaper
            }
          }
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "99%" }}>
                {t("ADD_CONTRACT")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={(event) => this.closeContractModal(false)}
                  onClick={(event) => this.closeContractModal(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent style={{ overflowY: "initial" }} dividers>
            <Grid container spacing={3}>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  error={!!error.title}
                  helperText={error.title}
                  name={"title"}
                  size={"small"}
                  variant={"outlined"}
                  value={this.state.title}
                  placeholder={t("CONTRACT_TITLE") + " *"}
                  onChange={(event) => this.onChange(event)}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"description"}
                  value={this.state.description}
                  onChange={(event) => this.onChange(event)}
                  placeholder={t("CONTRACT_DESCRIPTION")}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <FormControl
                  size={"small"}
                  variant={"outlined"}
                  className="custom-select-input"
                  error={!!error.type}
                >
                  <InputLabel htmlFor="type">
                    {t("RECEPIENT_PROVIDER_TYPE")} *
                  </InputLabel>
                  <Select
                    native
                    label="RECEPIENT_PROVIDER_TYPE"
                    name={"type"}
                    value={this.state.type}
                    size={"small"}
                    variant={"outlined"}
                    id="type"
                    onChange={(event) => this.onChange(event)}
                  >
                    <option value=""></option>
                    {providerTypeList.map(
                      (opt, key) =>
                        this.props.providerType !== opt.id && (
                          <option key={key} value={opt.id}>
                            {opt.title}
                          </option>
                        ),
                    )}
                  </Select>
                  {error.type && (
                    <span
                      style={{
                        color: "#f44336",
                        marginLeft: "0px",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {error.type}
                    </span>
                  )}
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <FormControl
                  size={"small"}
                  variant={"outlined"}
                  className="custom-select-input"
                >
                  <InputLabel htmlFor="typeId">
                    {t("RECEPIENT_PROVIDER")}
                  </InputLabel>
                  <Select
                    native
                    label="RECEPIENT_PROVIDER"
                    name={"typeId"}
                    size={"small"}
                    variant={"outlined"}
                    value={this.state.typeId}
                    id="typeId"
                    onChange={(event) => this.onChange(event)}
                  >
                    <option value="all">All</option>
                    {this.state.providerList.map((opt, key) => (
                      <option key={key} value={opt.id}>
                        {opt.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <TextField
                  error={!!error.effectiveDate}
                  helperText={error.effectiveDate}
                  name="effectiveDate"
                  id="date"
                  type="date"
                  size={"small"}
                  variant={"outlined"}
                  value={this.state.effectiveDate}
                  label={t("CONTRACT_EFFECTIVE_DATE") + " *"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => this.onChange(event)}
                  inputProps={{
                    //min: this.state.today,
                    max: this.state.expiryDate,
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <TextField
                  name="expiryDate"
                  id="date"
                  type="date"
                  size={"small"}
                  variant={"outlined"}
                  value={this.state.expiryDate}
                  label={t("CONTRACT_EXPIRY_DATE")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => this.onChange(event)}
                  inputProps={{ min: this.state.effectiveDate }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  // error={!!error.base64PdfDocument}
                  // helperText={error.base64PdfDocument}
                  inputProps={{
                    id: "documentFile",
                    accept: "application/pdf",
                  }}
                  type="file"
                  name={"documentFile"}
                  className="custom-file-input"
                  onChange={(event) =>
                    this.onDocumentUpload(event, "documentFile")
                  }
                  source={this.state.documentFile}
                  size={"small"}
                  variant={"outlined"}
                />
                <label
                  htmlFor="documentFile"
                  className={"input-file-label"}
                  style={{
                    border: error.base64PdfDocument
                      ? "1px solid rgb(244,67,54)"
                      : "",
                    color: error.base64PdfDocument ? "rgb(244,67,54)" : "",
                  }}
                >
                  <Icon>attach_file</Icon>
                  <label>
                    {" "}
                    {this.state.documentFile ? (
                      this.state.documentFile
                    ) : (
                      <span
                        className="input-file-placeholder"
                        style={{
                          color: error.base64PdfDocument
                            ? "rgb(244,67,54)"
                            : "",
                        }}
                      >
                        {t("UPLOAD_DOCUMENT_FILE_PDF_ONLY")}
                      </span>
                    )}
                  </label>
                </label>
                {error.base64PdfDocument && (
                  <span
                    style={{
                      color: "rgb(244,67,54)",
                      marginLeft: "0px",
                      fontSize: "0.75rem",
                      marginTop: "4px",
                    }}
                  >
                    {error.base64PdfDocument}
                  </span>
                )}
              </Grid>
              {/* <Grid item xs={6} >
                                <Input
                                    size={'small'}
                                    variant={'outlined'}
                                    name={'documentDescription'}
                                    value={this.state.documentDescription}
                                    onChange={event => this.onChange(event)}
                                    placeholder={t('DOCUMENT_DESCRIPTION')}
                                />
                            </Grid> */}
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"documentDescription"}
                  value={this.state.documentDescription}
                  onChange={(event) => this.onChange(event)}
                  placeholder={t("DOCUMENT_DESCRIPTION")}
                  inputProps={{ rows: 2, cols: 31 }}
                  multiline={true}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "20px" }}>
            {/* <Button onClick={event => this.closeContractModal(false)} color="primary">{t('CANCEL')}</Button> */}
            <Button
              onClick={(event) => this.closeContractModal(true)}
              color="primary"
            >
              {t("ADD")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Add contract documents modal */}
        <UploadDocumentsDialog
          open={this.state.open}
          close={this.closeDocumentDialog}
          contractId={this.state.selectedContractId}
          title={this.state.selectedContractTitle}
          effectiveDate={this.state.selectedEffectiveDate}
          expiryDate={this.state.selectedExpiryDate}
          providerId={this.props.tenantId}
          providerType={this.props.providerType}
          selectedContractReceiver={this.state.selectedContractReceiver}
        />
        {/* PDF VIEW */}
        <Dialog
          disableScrollLock={true}
          open={this.state.pdfView}
          maxWidth="lg"
          PaperComponent={this.draggableDialogPaper}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {t("THE_CONTRACT_DOCUMENT")}
          </DialogTitle>
          <DialogContent dividers>
            <PdfViewer base64PdfDocument={this.state.base64PdfDocument} />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.closePdfView(true)}
              color="primary"
            >
              {t("SAVE")}
            </Button>
            <Button
              onClick={(event) => this.closePdfView(false)}
              color="primary"
            >
              {t("CLOSE")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* edit contract data */}
        {this.state.openEditContract && (
          <EditContract
            open={this.state.openEditContract}
            close={this.closeUpdateContract}
            providerType={this.props.providerType}
            contractData={this.state.selectedContractToEdit}
            salesChannelProvidersList={this.state.salesChannelProvidersList}
            solutionProvidersList={this.state.solutionProvidersList}
            serviceProvidersList={this.state.serviceProvidersList}
          />
        )}
        {/* View contractors list dialog */}
        {this.state.showRequestorsDialog && (
          <ViewRequestorsDialog
            open={this.state.showRequestorsDialog}
            contractId={this.state.requestorsListContractId}
            contractTitle={this.state.requestedContractId}
            copyContract={this.state.copyContract}
            close={this.closeRequestorDialog}
          />
        )}
        {/* Delete contract confirmation */}
        <Dialog
          disableScrollLock={true}
          open={this.state.openDeleteDialog}
          maxWidth="sm"
          fullWidth={true}
          PaperComponent={this.draggableDialogPaper}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("DELETE_CONTRACT")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={() => this.closeDeleteConfirmation(false)}
                  onClick={() => this.closeDeleteConfirmation(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              {t("DELETE_CONTRACT_CONFIRMATION")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.closeDeleteConfirmation(false)}
              color="primary"
            >
              {t("NO")}
            </Button>
            <Button
              onClick={(event) => this.closeDeleteConfirmation(true)}
              color="primary"
            >
              {t("YES")}
            </Button>
          </DialogActions>
        </Dialog>
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };
const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ContractManagement));
